/* eslint-disable import/prefer-default-export */
import type { TranslatedEntity, TranslationEntity, File } from '@/entities/Entities';

export const translationFor =
  (language = 'de') =>
  <T extends TranslationEntity>(data: TranslatedEntity<T>, prop: keyof T) =>
      data?.translations?.find((value) => value.language === language)?.[prop];

export const thumbnailUrl = (file: File, params?: { width: number; height: number }) =>
  `/files/${file.id}/thumbnail?${new URLSearchParams(
    params
      ? {
        width: params.width.toString(),
        height: params.height.toString(),
      }
      : {},
  )}`;
